<template>
  <v-layout
    row
    wrap
    :class="[{'pb-3': !$vuetify.breakpoint.xsOnly}]"
    justify-center
  >
    <v-flex
      xs3
      class="jutify-center cursor-pointer"
      @click="$emit('openShareLinkDialog')"
    >
      <div class="option">
        <v-layout row wrap>
          <v-flex xs12 md2 :class="{'pr-2': !$vuetify.breakpoint.xsOnly}">
            <v-icon size="24px" :class="['active', {'align-icon': $vuetify.breakpoint.xsOnly}]">
              share
            </v-icon>
          </v-flex>
          <v-flex xs12 md10>
            <span class="label active option">
              {{ $t('message.bizgainOnboarding.summaryPage.Share') }}
            </span>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
    <v-flex
      xs3
      class="jutify-center cursor-pointer"
      @click="$emit('onContinueSignup')"
    >
      <div class="option">
        <v-layout row wrap>
          <v-flex xs12 md2 :class="{'pr-2': !$vuetify.breakpoint.xsOnly}">
            <img :src="!isIncompleteSignup ? bizgainOnboardingImage.resumeIcon : bizgainOnboardingImage.resumeActiveIcon" :class="['resumeIcon', {'active': isIncompleteSignup}, {'scaled pb-1': $vuetify.breakpoint.xsOnly}]">
          </v-flex>
          <v-flex xs12 md10>
            <span
              v-if="!$vuetify.breakpoint.xsOnly"
              class="ml-2 label align-icon"
              :class="{'active': isIncompleteSignup}"
            >
              {{ $t('message.bizgainOnboarding.summaryPage.ContinueSignup') }}
            </span>
            <span
              v-if="$vuetify.breakpoint.xsOnly"
              class="ml-1 label option"
              :class="{'active': isIncompleteSignup}"
              style="padding-top: 0px !important;"
            >
              {{ $t('message.bizgainOnboarding.summaryPage.Continue') }}
            </span>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
    <v-flex
      xs3
      class="jutify-center cursor-pointer"
      @click="$emit('changeObjective')"
    >
      <div style="display: flex; justify-content: center;">
        <v-layout
          row
          wrap
          :class="{'ml-5': !$vuetify.breakpoint.xsOnly}"
        >
          <v-flex xs12 md2 :class="{'pr-2 mt-1': !$vuetify.breakpoint.xsOnly}">
            <!-- <img :src="bizgainOnboardingImage.changeIcon" class="imageIcon" :class="{'align-icon': $vuetify.breakpoint.xsOnly}"> -->
            <v-icon size="24px" :class="['active',{'align-icon': $vuetify.breakpoint.xsOnly}]">
              adjust
            </v-icon>
          </v-flex>
          <v-flex xs12 md10>
            <span v-if="!$vuetify.breakpoint.xsOnly" class="ml-1 label active" style="margin-top: 2px !important;">
              {{ $t('message.bizgainOnboarding.summaryPage.ChangeObjective') }}
            </span>
            <span v-if="$vuetify.breakpoint.xsOnly" class="label active option">
              {{ $t('message.bizgainOnboarding.summaryPage.Change') }}
            </span>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
    <v-flex
      xs3
      class="jutify-center cursor-pointer"
      @click="$emit('openRestartDialog')"
    >
      <div class="option cursor-pointer">
        <v-layout row wrap>
          <v-flex xs12 md2 :class="{'pr-2': !$vuetify.breakpoint.xsOnly}">
            <!-- <img :src="bizgainOnboardingImage.restartIcon" class="restartIcon align-icon" :class="{'align-icon': $vuetify.breakpoint.xsOnly}"> -->
            <v-icon size="24px" :class="['active',{'align-icon': $vuetify.breakpoint.xsOnly}]">
              refresh
            </v-icon>
          </v-flex>
          <v-flex xs12 md10>
            <span v-if="!$vuetify.breakpoint.xsOnly" class="ml-2 label active">
              {{ $t('message.bizgainOnboarding.summaryPage.RestartSignup') }}
            </span>
            <span v-if="$vuetify.breakpoint.xsOnly" class="ml-1 label active option">
              {{ $t('message.bizgainOnboarding.summaryPage.Restart') }}
            </span>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import { launchState, bizgainOnboardingImage } from '../../../constants';
import { VIcon, VFlex, VLayout } from 'vuetify/lib';
export default {
  components: {
    VLayout,
    VFlex,
    VIcon
  },
  data() {
    return {
      isIncompleteSignup: false,
      bizgainOnboardingImage
    }
  },
  created() {
    if(this.businessDetails.launchState <= launchState.LOCATIONTARGETING && !(this.businessDetails.targeting && this.businessDetails.targeting.location)){
      this.isIncompleteSignup = true;
    }
  },
  computed: {
    ...mapGetters(['businessDetails'])
  }
}
</script>
<style lang="scss" scoped>
  .active{
    color: #13ABB1;
  }

  .option{
    margin-left: auto !important;
    margin-right: auto !important;
  }
  .cursor-pointer{
    cursor: pointer;
  }

  .align-icon {
    margin-top: 1px !important;
  }
  .imageIcon{
  height: 24px;
  width: 24px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
 .resumeIcon{
  height: 30px;
  width: 30px;
  display: block;
  margin-left: auto;
  margin-right: auto;
 }

 .restartIcon{
  height: 24px;
  width: 24px;
  display: block;
  margin-left: auto;
  margin-right: auto;
 }
 .scaled
{
  transform: scale(1.3); /* Equal to scaleX(0.7) scaleY(0.7) */
}
</style>
